document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.what-we-do .swiper').forEach(function (el) {
    new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 10,
      loop: true,
      grabCursor: true,
      centeredSlides: false,
      resistance: false,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      slideToClickedSlide: true,
      lazy: {
        loadPrevNext: true,
      },
      breakpoints: {
        770: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        700: {
          slidesPerView: 1.7,
        },
        420: {
          slidesPerView: 1,
        },
        320: {
          spaceBetween: 10,
          resistance: false,
        },
      },
    });
  });
});
